export default {
    EMR_ORDER_CODES: [
        {
            order_code: "PHARMA",
            description: "Pharmacogenomics",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "TOXICO",
            description: "Toxicology",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "UTI",
            description: "UTI",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "CLINICALCHEM",
            description: "Clinical Chemistry",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "IDR",
            description: "RESPIRATORY",
            lab_case_type: "RESPIRATORY_PATHOGEN_PANEL",
            status: "true"
        },
        {
            order_code: "COVID-19",
            description: "COVID-19",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "DLW_UTISTD",
            description: "Urinary Tract Infections with STD",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_UTID",
            description: "Urinary Tract Infections only",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_ABR",
            description: "Antibiotic Resistance on UTI",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_UTI4",
            description: "UTI with STDS",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_COMP",
            description: "Comprehensive Panel for PGx",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PAAP",
            description: "Pain and Addiction Panel",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PP",
            description: "Psychiatric Panel",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_OP",
            description: "Oncology Panel",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_CAR",
            description: "Cardiac Panel",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_CBCwDiff",
            description: "Complete Blood Count with Diff",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CMP",
            description: "Comprehensive Metabolic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Lipid Panel",
            description: "Lipid Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Folate",
            description: "Folate Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Uric Acid",
            description: "Uric Acid Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Vitamin B12",
            description: "Vitamin B12 Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Urinalysis",
            description: "Urinalysis",
            lab_case_type: "URINALYSIS",
            status: "true"
        },
        {
            order_code: "DLW_Cholinesterase",
            description: "Cholinesterase Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CK",
            description: "Creatine Kinase Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_HCG+B",
            description: "Human Chorionic Gonodotropin Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Hgb A1C",
            description: "Haemoglobin A1C",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Lactate",
            description: "Lactate Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_LDH",
            description: "Lactate Dehydrogenase",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Lipase",
            description: "Test for Lipase",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Magnesium",
            description: "Test for Magnesium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Phosphorus",
            description: "Test for Phosphorous",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_TSH",
            description: "Thyroid Stimulating Harmone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_HIV Screen",
            description: "HIV Screen",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Homocysteine",
            description: "Test for Homocysteine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_GGT",
            description: "Gamma Glutamyl transferase",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Syphilis",
            description: "Syphilis Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_GC",
            description: "Gonorrhea Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_COV",
            description: "Covid  Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DWLSCR",
            description: "Screening Tests",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DWLCNT",
            description: "New Confirmation Test Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSAMP",
            description: "Amphetamines",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSBNZ",
            description: "Benzodiazepines",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSBUP",
            description: "Buprenorphene",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSCOC",
            description: "Cocaine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSFNT",
            description: "Fentanyl",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSGBP",
            description: "Gabapentin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSHMB",
            description: "Heroin Meatabolite",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSMTD",
            description: "Methadone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSMTA",
            description: "Methylenedioxy-amphetamine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSNOS",
            description: "Not Otherwise Specified",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSOPT",
            description: "Opiates",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSOOA",
            description: "Opioids and opiate analogs",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSOXD",
            description: "Oxycodone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSPCP",
            description: "Phencyclidine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSPGB",
            description: "Pregabalin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSPPX",
            description: "Propoxyphene",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSSMR",
            description: "Skeletal Muscle Relaxants",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSSTM",
            description: "Stimulants",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSTPD",
            description: "Tapentadol",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSTRM",
            description: "Tramadol",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSALK",
            description: "Alkaloids",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSCNN",
            description: "Cannabinoids",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSADP",
            description: "Anti Depressants",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSHPN",
            description: "Hypnotics",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLSOTD",
            description: "Other drugs",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "Devans_Resp",
            description: "Respiratory Panel",
            lab_case_type: "RESPIRATORY_PATHOGEN_PANEL",
            status: "true"
        },
        {
            order_code: "URINE CULTURES",
            description: "URINE CULTURES",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "STD URINE CULTURE",
            description: "STD URINE CULTURE",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "URINE CUTLURES",
            description: "URINE CULTURES",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "Food Allergens-25",
            description: "Food Allergens-25",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "Inhalant Allergens-36",
            description: "Inhalant Allergens-36",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "Bacterial Vaginosis",
            description: "Bacterial Vaginosisa",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "MH_COVID_19",
            description: "RT-PCR_Covid19",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "MH_RPP",
            description: "PCR- Respiratory Panel",
            lab_case_type: "RESPIRATORY_PATHOGEN_PANEL",
            status: "true"
        },
        {
            order_code: "MH_UTID",
            description: "PCR- UTI PANEL",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "MH_UTIwoSTI",
            description: "PCR- UTIw/oSTI",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "MH_ABR",
            description: "PCR_ABR",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "MH_COMP",
            description: "PGX- COMPREHENSIVE PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "MH_PAAP",
            description: "PGX- PAIN AND ADDICTION PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "MH_PP",
            description: "PGX- PSYCHIATRIC PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "MH_OP",
            description: "PGX- ONCOLOGY PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "MH_URINALYSIS",
            description: "Urinalysis",
            lab_case_type: "URINALYSIS"
        },
        {
            order_code: "MH_CAR",
            description: "PGX- CARDIAC PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "MH_CARDIO",
            description: "Genetics-Cardiomyopathy",
            lab_case_type: "CARDIAC",
            status: "true"
        },
        {
            order_code: "MH_PUL",
            description: "Genetics-Pulmonary",
            lab_case_type: "PULMONARY_PANEL",
            status: "true"
        },
        {
            order_code: "MH_PAD",
            description: "Genetics-Alzhiemers",
            lab_case_type: "PAD_ALZHEIMERS",
            status: "true"
        },
        {
            order_code: "MH_CGX",
            description: "Genetics-CGX",
            lab_case_type: "CGX_PANEL",
            status: "true"
        },
        {
            order_code: "MH_WND",
            description: "Wound Panel",
            lab_case_type: "WOUND",
            status: "true"
        },
        {
            order_code: "MH_RPP_COVID_19",
            description: "RPP + Covid19",
            lab_case_type: [
                "RESPIRATORY_PATHOGEN_PANEL",
                "COVID"
            ],
            status: "true"
        },
        {
            order_code: "MH_DIAB",
            description: "Genetics-Diabeties",
            lab_case_type: "DIABETES",
            status: "true"
        },
        {
            order_code: "MH_COVID_FLU",
            description: "Covid and Flu",
            lab_case_type: "COVID_FLU"
        },
        {
            order_code: "MH_ToxoIgG",
            description: "Toxo IgG",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_ToxoIgM",
            description: "Toxo IgM",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_AMP",
            description: "Tox-Amphetamines",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_BNZ",
            description: "Tox-Benzodiazepine",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_BUP",
            description: "Tox-Buprenorphine",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_FNT",
            description: "Tox-Fentanyl",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_GBP",
            description: "Tox-Gabapentin",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_HMB",
            description: "Tox-Heroin Metabolite",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_MTD",
            description: "Tox-Methadone",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_MTA",
            description: "Tox-Methylenedioxy-amphetamines",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_NOS",
            description: "Tox-Not Otherwise specified",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_OPT",
            description: "Tox-Opiates",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_OOA",
            description: "Tox-Opioids and Opiate Analogs",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_OXD",
            description: "Tox-Oxycodone",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_PCP",
            description: "Tox-PCP",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_PGB",
            description: "Tox-Pregabalin",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_PPX",
            description: "Tox-Propoxyphene",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_SMR",
            description: "Tox-Skeletal Muscle Relaxants",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_STM",
            description: "Tox-Stimulants",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_TPD",
            description: "Tox-Tapentadol",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_TRM",
            description: "Tox-Tramadol",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_ALK",
            description: "Tox-Alkaloids",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_CNN",
            description: "Tox-Cannabioids, Natural",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_ADP",
            description: "Tox-Anti Depressants (TCAs)",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_HPN",
            description: "Tox-Hypnotics",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_OTD",
            description: "Tox-Other Drugs",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_CNT",
            description: "Tox- Confirmation Test",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_SCREEN",
            description: "Tox- Screen Test",
            lab_case_type: "TOXICOLOGY"
        },
        {
            order_code: "MH_CMP",
            description: "Comp Metabolic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_BMP",
            description: "Basic Metabolic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_RP",
            description: "Renal Panel",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HP",
            description: "Hepatic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LP",
            description: "Lipid Panel",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_IA36",
            description: "Inhalent Allerns-36",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FA25",
            description: "Food Allergens-25",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_A1AT",
            description: "A1 Antitrypsin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AD",
            description: "Aldosterone",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AP",
            description: "Alk Phos",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_ALT",
            description: "ALT",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AL",
            description: "Amylase",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_HAV",
            description: "Anti-HAV",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_HAV IGM",
            description: "Anti-HAV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_HBC",
            description: "Anti-Hbc",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_HBC IGM",
            description: "Anti-Hbc IgM",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_HBS",
            description: "Anti-HBs",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_HCV",
            description: "Anti-HCV",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_TG",
            description: "Anto-TG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AN_TPO",
            description: "Anti-TPO",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_APTT",
            description: "APTT",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_AST",
            description: "AST",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_BD",
            description: "Bilirubin, Direct",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_BT",
            description: "Bilirubin, Total",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_BNP",
            description: "BNP",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_BUN",
            description: "BUN",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CA",
            description: "Covid Antibodies",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_C3",
            description: "C3",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_C4",
            description: "C4",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CA125",
            description: "CA 125",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CA15_3",
            description: "CA 15-3",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CA19_9",
            description: "CA 19-9",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CBC",
            description: "CBC w/Diff",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CEA",
            description: "CEA",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CH",
            description: "Chloride",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CHT",
            description: "Cholesterol, Total",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CK",
            description: "CK",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CK_MB",
            description: "CK-MB",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CO2",
            description: "CO2",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CRT",
            description: "Cortisol",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CPT",
            description: "C-Peptide",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_CT",
            description: "Creatinine",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_DHEA_S",
            description: "DHEA-S",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_DX",
            description: "Digoxin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_EA_IGG",
            description: "EA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_EBNA_IGG",
            description: "EBNA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_EBV_IGM",
            description: "EBV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_ESR",
            description: "ESR",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_ESD",
            description: "Estradiol",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FOB",
            description: "Fecal Occult Blood",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FL",
            description: "Folate",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FRT",
            description: "Ferritin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FT3",
            description: "Free T3",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FT4",
            description: "Free T4",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_FSH",
            description: "FSH",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_GGT",
            description: "GGT",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_GLC",
            description: "Glucose",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HSV_1IGG",
            description: "HSV-1 IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HSV_2IGG",
            description: "HSV-2 IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HP_IGG",
            description: "H.Pylori IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HBSAG",
            description: "HBsAg",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HCG_B",
            description: "HCG+B",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HDL",
            description: "HDL",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HGBA1C",
            description: "HgbA1C",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HIVS",
            description: "HIV Screen",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_HSCRP",
            description: "hsCRP",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_IGA",
            description: "IgA",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_IGG",
            description: "IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_IGM",
            description: "IgM",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_INS",
            description: "Insilin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_IR_TIBC",
            description: "Iron and TIBC",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LIT",
            description: "Lithium",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LCT",
            description: "Lactate",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LDH",
            description: "LDH",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LDL",
            description: "LDL",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LH",
            description: "LH",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_LIP",
            description: "Lipase",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_MO",
            description: "Mono",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_MGS",
            description: "Magnesium",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_MSIGG",
            description: "Measles IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_MMIGG",
            description: "Mumps IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_MYG",
            description: "Myoglobin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PO",
            description: "Potassium",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PAL",
            description: "Prealbumin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PC",
            description: "Procalcitionin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PGS",
            description: "Progesterone",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PLN",
            description: "Prolactin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PSAF",
            description: "PSA, Free",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PSAT",
            description: "PSA, Total",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PT",
            description: "PT",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_PTH",
            description: "PTH",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_QUN",
            description: "Quantiferon",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TBG",
            description: "TB Gold",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_RUIGG",
            description: "Rubella IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_RUIGM",
            description: "Rubella Igm",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_RD",
            description: "Renin,Direct",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_RC",
            description: "Reticulocytes",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_RF",
            description: "Rheumatoid Factor",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_SHBG",
            description: "SHBG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_SYP",
            description: "Syphilis",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_SO",
            description: "Sodium",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TXIGG",
            description: "Toxo IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TXIGM",
            description: "Toxo IgM",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TS",
            description: "Testosterone",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TP",
            description: "Total Protein",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TT3",
            description: "Total T3",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TT4",
            description: "Total T4",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TRF",
            description: "Transferrin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TRC",
            description: "Triglycerides",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_TUT",
            description: "T-Uptake",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_UA",
            description: "Uric Acid",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_UM",
            description: "Urine Microalbumin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_VCAIGG",
            description: "VCA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_VB12",
            description: "Vitamin B12",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_VD",
            description: "Vitamin D",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_VAVIGG",
            description: "VZV IgG",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_VA",
            description: "Valproic acid",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_VCM",
            description: "Vancomycin",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_WELLNESS_FM",
            description: "WellnessnPanel(Female)",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "MH_WELLNESS_M",
            description: "WellnessnPanel(Male)",
            lab_case_type: "CLINICAL_CHEMISTRY"
        },
        {
            order_code: "DLW_Covid19",
            description: "RT-PCR_Covid19",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "DLW_RPP + Covid19",
            description: "RPP + Covid19",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "DLW_RPP",
            description: "PCR- Respiratory Panel",
            lab_case_type: "RESPIRATORY_PATHOGEN_PANEL",
            status: "true"
        },
        {
            order_code: "DLW_Covid_FLU",
            description: "PCR - COVID FLU",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "DLW_UTIwoSTD",
            description: "PCR- UTIw/oSTD",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_WOUND",
            description: "PCR - WOUND",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PGX_COMP",
            description: "PGX- COMPREHENSIVE PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PGX_PAIN",
            description: "PGX- PAIN AND ADDICTION PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PGX_PSYCH",
            description: "PGX- PSYCHIATRIC PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PGX_ONCO",
            description: "PGX- ONCOLOGY PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_PGX_CARD",
            description: "PGX- CARDIAC PANEL",
            lab_case_type: "PGX_TEST",
            status: "true"
        },
        {
            order_code: "DLW_Basic Metabolic Panel",
            description: "Basic Metabolic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Hepatic Panel",
            description: "Hepatic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Electrolyte Panel",
            description: "Electrolyte Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Diabetes Profile",
            description: "Diabetes Profile",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Tumor Markers",
            description: "Tumor Markers",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Infectious Disease",
            description: "Infectious Disease",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Vitamin D",
            description: "Vitamin D",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_PTH",
            description: "PTH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Prealbumin",
            description: "Prealbumin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Ferritin",
            description: "Ferritin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Osteocalcin",
            description: "Osteocalcin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Cardiac Markers",
            description: "Cardiac Markers",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Transferrin",
            description: "Transferrin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ESR",
            description: "ESR",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ACTH",
            description: "ACTH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_AFP",
            description: "AFP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Albumin",
            description: "Albumin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Aldosterone",
            description: "Aldosterone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_AlkPhos",
            description: "AlkPhos",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ALT",
            description: "ALT",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_AMH",
            description: "AMH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Ammonia",
            description: "Ammonia",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ AT",
            description: "Amylase- total",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-CCP",
            description: "Anti-CCP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-HAV",
            description: "Anti-HAV",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-Hbc",
            description: "Anti-Hbc",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-HbcIgM",
            description: "Anti-HbcIgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-HBs",
            description: "Anti-HBs",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-HCV",
            description: "Anti-HCV",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-Tg",
            description: "Anti-Tg",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-TPO",
            description: "Anti-TPO",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ Anti-HAV IgM",
            description: "Anti-HAV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Anti-TSHR",
            description: "Anti-TSHR",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_APOA1",
            description: "APOA1",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_APO B",
            description: "APO B",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Antistreptolysin O",
            description: "Antistreptolysin O",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_AST",
            description: "AST",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Bilirubin - Direct",
            description: "Bilirubin - Direct",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_proBNP II",
            description: "proBNP II",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_BUN",
            description: "BUN",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_C3",
            description: "C3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_C4",
            description: "C4",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CA 125",
            description: "CA 125",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CA 15-3",
            description: "CA 15-3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CA 19-9",
            description: "CA 19-9",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Calcitonin",
            description: "Calcitonin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Calcium",
            description: "Calcium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Carcinoembryonic Antigen",
            description: "Carcinoembryonic Antigen",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Ceruloplasmin",
            description: "Ceruloplasmin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Chloride",
            description: "Chloride",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CK-MB",
            description: "CK-MB",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CO2",
            description: "CO2",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CortisolAM",
            description: "Cortisol (AM)",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_C-Peptide",
            description: "C-Peptide",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Creatinine",
            description: "Creatinine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Cyfra21-1",
            description: "Cyfra21-1",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Cystatin C",
            description: "Cystatin C",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_D-Dimer",
            description: "D-Dimer",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_DHEA-S",
            description: "DHEA-S",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Digoxin",
            description: "Digoxin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_EA IgG",
            description: "EA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_EBNA IgG",
            description: "EBNA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_EBV IgM",
            description: "EBV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Estradiol",
            description: "Estradiol",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Coagulation Factor VII",
            description: "Coagulation Factor VII",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Fibrinogen",
            description: "Fibrinogen",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Free T3",
            description: "Free T3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Free T4",
            description: "Free T4",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Fructosamine",
            description: "Fructosamine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_FSH",
            description: "FSH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Haptoglobin",
            description: "Haptoglobin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_HBsAg",
            description: "HBsAg",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_hGH",
            description: "hGH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_hsCRP",
            description: "hsCRP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_IgA",
            description: "IgA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_IgE II",
            description: "IgE II",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_IgG",
            description: "IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_IgM",
            description: "IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Insulin",
            description: "Insulin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Iron and TIBC",
            description: "Iron and TIBC",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_LH",
            description: "LH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Lipoprotein(a)",
            description: "Lipoprotein(a)",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Measles IgG",
            description: "Measles IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Mumps IgG",
            description: "Mumps IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Myoglobin",
            description: "Myoglobin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Potassium",
            description: "Potassium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Procalcitonin",
            description: "Procalcitonin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Progesterone",
            description: "Progesterone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Prolactin",
            description: "Prolactin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Protein C",
            description: "Protein C",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Free PSA",
            description: "Free PSA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Total PSA",
            description: "Total PSA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_PT",
            description: "PT",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Quantiferon TB Gold",
            description: "Quantiferon TB Gold",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Direct Renin",
            description: "Direct Renin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Rheumatoid Factor",
            description: "Rheumatoid Factor",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_SHBG",
            description: "SHBG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Sodium",
            description: "Sodium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Testosterone",
            description: "Testosterone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Total T3",
            description: "Total T3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Total T4",
            description: "Total T4",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Triglycerides",
            description: "Triglycerides",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Troponin T",
            description: "Troponin T",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_T-Uptake",
            description: "T-Uptake",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_VCA IgG",
            description: "VCA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_VZV IgG",
            description: "VZV IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Retic",
            description: "Retic",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Coagulation Factor VIII",
            description: "Coagulation Factor VIII",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Thrombin Time",
            description: "Thrombin Time",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ Total Protein",
            description: "Total Protein",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_UAGLU",
            description: "Glucose",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_HSV1",
            description: "HSV 1 IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_HSV2",
            description: "HSV-2 IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_RP",
            description: "Renal Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_PTT",
            description: "APTT",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_RubellaIgG",
            description: "Rubella IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_RubellaIgM",
            description: "Rubella IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ToxoIgG",
            description: "Toxo IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_ToxoIgM",
            description: "Toxo IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_LIT",
            description: "Lithium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_VALPA",
            description: "Valproic Acid",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_VANT",
            description: "Vancomycin (Trough)",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_VANP",
            description: "Vancomycin (Peak)",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_TFPSA",
            description: "Total and Free PSA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_BreathTest",
            description: "H. Pylori Breath Test",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_MAL",
            description: "Microalbumin, Random Urine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_PSMEAR",
            description: "Pap Smear",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Urine Protein",
            description: "Protein, Random Urine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Levetiracetam",
            description: "Levetiracetam",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Tacrolimus",
            description: "Tacrolimus",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_SPE",
            description: "Serum Protein Electrophoresis",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_OBF",
            description: "Occult Blood, Fecal, Immunoassay",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_FOB",
            description: "Fecal Occult Blood",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Pap Smear w/HPV",
            description: "Pap Smear w/HPV",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Ret",
            description: "Reticulocyte Count",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_CortisolPM",
            description: "Cortisol (PM)",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_COVS",
            description: "Anti-SARS-CoV-2 S",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_AMP",
            description: "Tox-Amphetamines",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_BNZ",
            description: "Tox-Benzodiazepine",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_BUP",
            description: "Tox-Buprenorphine",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_COC",
            description: "Tox-Cocaine",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_FNT",
            description: "Tox-Fentanyl",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_GBP",
            description: "Tox-Gabapentin",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_HMB",
            description: "Tox-Heroin Metabolite",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_MTD",
            description: "Tox-Methadone",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_MTA",
            description: "Tox-Methylenedioxy-amphetamines",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_NOS",
            description: "Tox-Not Otherwise specified",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_OPT",
            description: "Tox-Opiates",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_OOA",
            description: "Tox-Opioids and Opiate Analogs",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_OXD",
            description: "Tox-Oxycodone",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_PCP",
            description: "Tox-PCP",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_PGB",
            description: "Tox-Pregabalin",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_PPX",
            description: "Tox-Propoxyphene",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_SMR",
            description: "Tox-Skeletal Muscle Relaxants",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_STM",
            description: "Tox-Stimulants",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_TPD",
            description: "Tox-Tapentadol",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_TRM",
            description: "Tox-Tramadol",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_ALK",
            description: "Tox-Alkaloids",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_CNN",
            description: "Tox-Cannabioids, Natural",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_ADP",
            description: "Tox-Anti Depressants (TCAs)",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_HPN",
            description: "Tox-Hypnotics",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_OTD",
            description: "Tox-Other Drugs",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_CNT",
            description: "Tox- Confirmation Test",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_SCR",
            description: "Tox- Screening",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_UTISD",
            description: "UTI w/o STD",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_UTIwoSTI",
            description: "Devansh_UTIwoSTI",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "Urine gonorrhea",
            description: "Neisseria Gonorrhoeae",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "Urine Chlamydia",
            description: "Chlamydia Trachomatis",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLWOST",
            description: "Oral Samples Test Menu",
            lab_case_type: "TOXICOLOGY",
            status: "true"
        },
        {
            order_code: "DLW_9017 Diabetes Profile",
            description: "9017 Diabetes Profile",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "proBNP II",
            description: "proBNP II",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Hepatitis",
            description: "Hepatitis",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Acid Glycoprotein",
            description: "DLW_α1-Acid Glycoprotein",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Antitrypsin",
            description: "DLW_α1-Antitrypsin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "DLW_Microglobulin",
            description: "DLW_β2-Microglobulin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "RPP + Covid19",
            description: "RPP + Covid19",
            lab_case_type: [
                "COVID",
                "RESPIRATORY_PATHOGEN_PANEL"
            ],
            status: "true"
        },
        {
            order_code: "Respiratory Panel",
            description: "PCR- Respiratory Panel",
            lab_case_type: "RESPIRATORY_PATHOGEN_PANEL",
            status: "true"
        },
        {
            order_code: "Covid 19",
            description: "covid",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "MH_UTISTD",
            description: "PCR- UTI PANEL",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "MGH_Cov",
            description: "",
            lab_case_type: "COVID 19",
            status: "true"
        },
        {
            order_code: "MGH_Resp",
            description: "",
            lab_case_type: "RESPIRATORY_PATHOGEN_PANEL",
            status: "true"
        },
        {
            order_code: "MGH_PGX",
            description: "",
            lab_case_type: "PGX_PANEL",
            status: "true"
        },
        {
            order_code: "MGH_Cardiac",
            description: "",
            lab_case_type: "CARDIAC_PANEL",
            status: "true"
        },
        {
            order_code: "MGH_Pulomonary",
            description: "",
            lab_case_type: "PULMONARY_PANEL",
            status: "true"
        },
        {
            order_code: "MGH_CGX",
            description: "",
            lab_case_type: "CGX_PANEL",
            status: "true"
        },
        {
            order_code: "MGH_PAD",
            description: "",
            lab_case_type: "PAD(ALZHEIMERS)",
            status: "true"
        },
        {
            order_code: "MGH_DIABETES",
            description: "",
            lab_case_type: "DIABETES",
            status: "true"
        },
        {
            order_code: "DLW_UA_REF_UTI",
            description: "PCR- UA REFLEX UTI PANEL",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_UA_REF_UTIwoSTI",
            description: "PCR- UA REFLEX UTI without STI PANEL",
            lab_case_type: "UTI",
            status: "true"
        },
        {
            order_code: "DLW_GASTRO",
            lab_case_type: "GASTRO",
            description: "GASTRO",
            status: true
        },
        {
            order_code: "DLW_NAIL",
            lab_case_type: "NAIL",
            description: "NAIL",
            status: true
        },
        {
            order_code: "DLW_STI",
            lab_case_type: "GTI STI",
            description: "GTI STI",
            status: true
        },
        {
            order_code: "Covid19",
            description: "RT-PCR_Covid19",
            lab_case_type: "COVID",
            status: "true"
        },
        {
            order_code: "Covid_FLU",
            description: "PCR - COVID FLU",
            lab_case_type: "COVID_FLU",
            status: "true"
        },
        {
            order_code: "Anti-HAV IgM",
            description: "Anti-HAV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "dlw_Iron and TIBC",
            description: "Iron and TIBC",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "dlw_LDH",
            description: "LDH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            status: "true"
        },
        {
            order_code: "MH_CBCwDiff",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "CBC w Diff",
            status: true
        },
        {
            order_code: "MH_Basic Metabolic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Basic Metabolic Panel",
            status: true
        },
        {
            order_code: "MH_Hepatic Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Hepatic Panel",
            status: true
        },
        {
            order_code: "MH_Electrolyte Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Electrolyte Panel",
            status: true
        },
        {
            order_code: "MH_Lipid Panel",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Lipid Panel",
            status: true
        },
        {
            order_code: "MH_9017 Diabetes Profile",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "9017 Diabetes Profile",
            status: true
        },
        {
            order_code: "MH_Tumor Markers",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Tumor Markers",
            status: true
        },
        {
            order_code: "MH_Infectious Disease",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Infectious Disease",
            status: true
        },
        {
            order_code: "MH_Folate",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Folate",
            status: true
        },
        {
            order_code: "MH_Vitamin D",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Vitamin D",
            status: true
        },
        {
            order_code: "MH_Prealbumin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Prealbumin",
            status: true
        },
        {
            order_code: "MH_Ferritin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Ferritin",
            status: true
        },
        {
            order_code: "MH_Uric Acid",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Uric Acid",
            status: true
        },
        {
            order_code: "MH_Vitamin B12",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Vitamin B12",
            status: true
        },
        {
            order_code: "MH_Osteocalcin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Osteocalcin",
            status: true
        },
        {
            order_code: "MH_Cardiac Markers",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Cardiac Markers",
            status: true
        },
        {
            order_code: "MH_Urinalysis",
            lab_case_type: "URINALYSIS",
            description: "Urinalysis",
            status: true
        },
        {
            order_code: "MH_Transferrin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Transferrin",
            status: true
        },
        {
            order_code: "MH_ACTH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "ACTH",
            status: true
        },
        {
            order_code: "MH_AFP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "AFP",
            status: true
        },
        {
            order_code: "MH_Albumin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Albumin",
            status: true
        },
        {
            order_code: "MH_Aldosterone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Aldosterone",
            status: true
        },
        {
            order_code: "MH_AlkPhos",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "AlkPhos",
            status: true
        },
        {
            order_code: "MH_AMH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "AMH",
            status: true
        },
        {
            order_code: "MH_Ammonia",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Ammonia",
            status: true
        },
        {
            order_code: "MH_ AT",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Amylase- total",
            status: true
        },
        {
            order_code: "MH_Anti-CCP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-CCP",
            status: true
        },
        {
            order_code: "MH_Anti-HAV",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-HAV",
            status: true
        },
        {
            order_code: "MH_Anti-Hbc",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-Hbc",
            status: true
        },
        {
            order_code: "MH_Anti-HbcIgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-HbcIgM",
            status: true
        },
        {
            order_code: "MH_Anti-HBs",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-HBs",
            status: true
        },
        {
            order_code: "MH_Anti-HCV",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-HCV",
            status: true
        },
        {
            order_code: "MH_Anti-Tg",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-Tg",
            status: true
        },
        {
            order_code: "MH_Anti-TPO",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-TPO",
            status: true
        },
        {
            order_code: "MH_ Anti-HAV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-HAV IgM",
            status: true
        },
        {
            order_code: "MH_Anti-TSHR",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-TSHR",
            status: true
        },
        {
            order_code: "MH_APOA1",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "APOA1",
            status: true
        },
        {
            order_code: "MH_APO B",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "APO B",
            status: true
        },
        {
            order_code: "MH_Antistreptolysin O",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Antistreptolysin O",
            status: true
        },
        {
            order_code: "MH_Bilirubin - Direct",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Bilirubin - Direct",
            status: true
        },
        {
            order_code: "MH_CA 125",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "CA 125",
            status: true
        },
        {
            order_code: "MH_CA 15-3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "CA 15-3",
            status: true
        },
        {
            order_code: "MH_CA 19-9",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "CA 19-9",
            status: true
        },
        {
            order_code: "MH_Calcitonin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Calcitonin",
            status: true
        },
        {
            order_code: "MH_Calcium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Calcium",
            status: true
        },
        {
            order_code: "MH_Carcinoembryonic Antigen",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Carcinoembryonic Antigen",
            status: true
        },
        {
            order_code: "MH_Ceruloplasmin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Ceruloplasmin",
            status: true
        },
        {
            order_code: "MH_Chloride",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Chloride",
            status: true
        },
        {
            order_code: "MH_Cholinesterase",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Cholinesterase",
            status: true
        },
        {
            order_code: "MH_CK-MB",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "CK-MB",
            status: true
        },
        {
            order_code: "MH_CortisolAM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Cortisol (AM)",
            status: true
        },
        {
            order_code: "MH_C-Peptide",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "C-Peptide",
            status: true
        },
        {
            order_code: "MH_Creatinine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Creatinine",
            status: true
        },
        {
            order_code: "MH_Cyfra21-1",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Cyfra21-1",
            status: true
        },
        {
            order_code: "MH_Cystatin C",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Cystatin C",
            status: true
        },
        {
            order_code: "MH_D-Dimer",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "D-Dimer",
            status: true
        },
        {
            order_code: "MH_DHEA-S",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "DHEA-S",
            status: true
        },
        {
            order_code: "MH_Digoxin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Digoxin",
            status: true
        },
        {
            order_code: "MH_EA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "EA IgG",
            status: true
        },
        {
            order_code: "MH_EBNA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "EBNA IgG",
            status: true
        },
        {
            order_code: "MH_EBV IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "EBV IgM",
            status: true
        },
        {
            order_code: "MH_Estradiol",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Estradiol",
            status: true
        },
        {
            order_code: "MH_Coagulation Factor VII",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Coagulation Factor VII",
            status: true
        },
        {
            order_code: "MH_Fibrinogen",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Fibrinogen",
            status: true
        },
        {
            order_code: "MH_Free T3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Free T3",
            status: true
        },
        {
            order_code: "MH_Free T4",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Free T4",
            status: true
        },
        {
            order_code: "MH_Fructosamine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Fructosamine",
            status: true
        },
        {
            order_code: "MH_Haptoglobin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Haptoglobin",
            status: true
        },
        {
            order_code: "MH_HBsAg",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "HBsAg",
            status: true
        },
        {
            order_code: "MH_HCG+B",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "HCG+B",
            status: true
        },
        {
            order_code: "MH_Hgb A1C",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Hgb A1C",
            status: true
        },
        {
            order_code: "MH_hGH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "hGH",
            status: true
        },
        {
            order_code: "MH_hsCRP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "hsCRP",
            status: true
        },
        {
            order_code: "MH_IgA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "IgA",
            status: true
        },
        {
            order_code: "MH_IgE II",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "IgE II",
            status: true
        },
        {
            order_code: "MH_IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "IgG",
            status: true
        },
        {
            order_code: "MH_IgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "IgM",
            status: true
        },
        {
            order_code: "MH_Insulin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Insulin",
            status: true
        },
        {
            order_code: "MH_Iron and TIBC",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Iron and TIBC",
            status: true
        },
        {
            order_code: "MH_Lactate",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Lactate",
            status: true
        },
        {
            order_code: "MH_Lipase",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Lipase",
            status: true
        },
        {
            order_code: "MH_Lipoprotein(a)",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Lipoprotein(a)",
            status: true
        },
        {
            order_code: "MH_Magnesium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Magnesium",
            status: true
        },
        {
            order_code: "MH_Measles IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Measles IgG",
            status: true
        },
        {
            order_code: "MH_Mumps IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Mumps IgG",
            status: true
        },
        {
            order_code: "MH_Myoglobin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Myoglobin",
            status: true
        },
        {
            order_code: "MH_Phosphorus",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Phosphorous",
            status: true
        },
        {
            order_code: "MH_Potassium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Potassium",
            status: true
        },
        {
            order_code: "MH_Procalcitonin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Procalcitonin",
            status: true
        },
        {
            order_code: "MH_Progesterone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Progesterone",
            status: true
        },
        {
            order_code: "MH_Prolactin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Prolactin",
            status: true
        },
        {
            order_code: "MH_Protein C",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Protein C",
            status: true
        },
        {
            order_code: "MH_Free PSA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Free PSA",
            status: true
        },
        {
            order_code: "MH_Total PSA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Total PSA",
            status: true
        },
        {
            order_code: "MH_Quantiferon TB Gold",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Quantiferon TB Gold",
            status: true
        },
        {
            order_code: "MH_Direct Renin",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Direct Renin",
            status: true
        },
        {
            order_code: "MH_Rheumatoid Factor",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Rheumatoid Factor",
            status: true
        },
        {
            order_code: "MH_Sodium",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Sodium",
            status: true
        },
        {
            order_code: "MH_Testosterone",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Testosterone",
            status: true
        },
        {
            order_code: "MH_Total T3",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Total T3",
            status: true
        },
        {
            order_code: "MH_Total T4",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Total T4",
            status: true
        },
        {
            order_code: "MH_Triglycerides",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Triglycerides",
            status: true
        },
        {
            order_code: "MH_Troponin T",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Troponin T",
            status: true
        },
        {
            order_code: "MH_TSH",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "TSH",
            status: true
        },
        {
            order_code: "MH_T-Uptake",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "T-Uptake",
            status: true
        },
        {
            order_code: "MH_VCA IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "VCA IgG",
            status: true
        },
        {
            order_code: "MH_VZV IgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "VZV IgG",
            status: true
        },
        {
            order_code: "MH_Retic",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Retic",
            status: true
        },
        {
            order_code: "MH_HIV Screen",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "HIV Screen",
            status: true
        },
        {
            order_code: "MH_Coagulation Factor VIII",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Coagulation Factor VIII",
            status: true
        },
        {
            order_code: "MH_Thrombin Time",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Thrombin Time",
            status: true
        },
        {
            order_code: "MH_ Total Protein",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Total Protein",
            status: true
        },
        {
            order_code: "MH_Homocysteine",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Homocysteine",
            status: true
        },
        {
            order_code: "MH_Syphilis",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Syphilis",
            status: true
        },
        {
            order_code: "MH_GC",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "General Chemistry",
            status: true
        },
        {
            order_code: "MH_UAGLU",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Glucose",
            status: true
        },
        {
            order_code: "MH_HSV1",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "HSV 1 IgG",
            status: true
        },
        {
            order_code: "MH_HSV2",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "HSV-2 IgG",
            status: true
        },
        {
            order_code: "MH_PTT",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "APTT",
            status: true
        },
        {
            order_code: "MH_RubellaIgG",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Rubella IgG",
            status: true
        },
        {
            order_code: "MH_RubellaIgM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Rubella IgM",
            status: true
        },
        {
            order_code: "MH_VALPA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Valproic Acid",
            status: true
        },
        {
            order_code: "MH_VANT",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Vancomycin (Trough)",
            status: true
        },
        {
            order_code: "MH_VANP",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Vancomycin (Peak)",
            status: true
        },
        {
            order_code: "MH_TFPSA",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Total and Free PSA",
            status: true
        },
        {
            order_code: "MH_BreathTest",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "H. Pylori Breath Test",
            status: true
        },
        {
            order_code: "MH_MAL",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Microalbumin, Random Urine",
            status: true
        },
        {
            order_code: "MH_PSMEAR",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Pap Smear",
            status: true
        },
        {
            order_code: "MH_Urine Protein",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Protein, Random Urine",
            status: true
        },
        {
            order_code: "MH_Levetiracetam",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Levetiracetam",
            status: true
        },
        {
            order_code: "MH_Tacrolimus",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Tacrolimus",
            status: true
        },
        {
            order_code: "MH_SPE",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Serum Protein Electrophoresis",
            status: true
        },
        {
            order_code: "MH_OBF",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Occult Blood, Fecal, Immunoassay",
            status: true
        },
        {
            order_code: "MH_Pap Smear w/HPV",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Pap Smear w/HPV",
            status: true
        },
        {
            order_code: "MH_COV",
            lab_case_type: "COVID",
            description: "Anti-SARS-CoV-2",
            status: true
        },
        {
            order_code: "MH_Ret",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Reticulocyte Count",
            status: true
        },
        {
            order_code: "MH_CortisolPM",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Cortisol (PM)",
            status: true
        },
        {
            order_code: "MH_COVS",
            lab_case_type: "CLINICAL_CHEMISTRY",
            description: "Anti-SARS-CoV-2 S",
            status: true
        },
        {
            order_code: "Mh_STI",
            lab_case_type: "GTI STI",
            description: "GTI STI",
            status: true
        },
        {
            order_code: "MH_WOMENS_HELATH",
            lab_case_type: "GTI WOMENS HEALTH",
            description: "GTI WOMENS HEALTH",
            status: true
        },
        {
            order_code: "MH_NAIL",
            lab_case_type: "NAIL",
            description: "NAIL",
            status: true
        },
        {
            order_code: "MH_GASTRO",
            lab_case_type: "GASTRO",
            description: "GASTRO",
            status: true
        }
    ]
}